import React from "react";
import { useHistory } from "react-router-dom";
import { CircleUserRound } from "lucide-react";
import { IconButton } from "../ui/Button/index.js";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../Store/AuthStore.jsx";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "../ui/DropdownMenu.jsx";

/**
 * AccountMenu component that handles user profile interactions and logout.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isLoggedIn - Authentication status.
 * @param {Function} props.logout - Store logout function.
 */
export default function AccountMenu({ isLoggedIn, logout }) {
  const { t } = useTranslation();
  const history = useHistory();
  const { userData } = useAuthStore();

  if (!isLoggedIn) return null;

  const userImage = userData?.picture || userData?.image;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <IconButton
          variant="ghost"
          size="icon"
          icon={
            userImage ? (
              <img
                src={userImage}
                alt="Profile"
                className="w-9 h-9 rounded-full border border-neutral-200 object-cover"
              />
            ) : (
              <CircleUserRound className="w-9 h-9 text-neutral-600" />
            )
          }
          tooltip={t("navigation.profile")}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => history.push("/profile")}>
          {t("navigation.myAccount")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => history.push("/settings")}>
          {t("navigation.settings", "Settings")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={logout} className="text-red-500">
          {t("navigation.logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
